import { render, staticRenderFns } from "./BoardSelectableIcon.vue?vue&type=template&id=47d959be"
import script from "./BoardSelectableIcon.vue?vue&type=script&lang=js"
export * from "./BoardSelectableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports